import { OWNER_ID } from '@btime/constants'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { useProfile } from './_load/ProfileLoader'
import { useRemoveProfile } from './_requests/removeProfile'
import { useSaveProfile } from './_requests/saveProfile'
import Button from '../../../packages/kiti/components/actions/Button'
import Form from '../../../packages/kiti/components/form/form/Form'
import GeneralSection from './sections/GeneralSection'
import SubmitBar from '../../../packages/kiti/components/form/SubmitBar'

const EditProfileForm = () => {
  const profile = useProfile()
  const [onSubmit, { loading: loadingSave, error }] = useSaveProfile()
  const [onRemove, { loading: loadingRemove }] = useRemoveProfile()
  const { t } = useTranslation('common')

  const loading = loadingSave || loadingRemove

  return (
    <Form loading={loading} onSubmit={onSubmit} initialState={profile || {}}>
      <GeneralSection />
      <SubmitBar loading={loading} error={error}>
        {profile?.id && profile.name !== 'owner' && (
          <Button loading={loading} onClick={onRemove} color="red" transparent>
            {t('remove')}
          </Button>
        )}
      </SubmitBar>
    </Form>
  )
}

export default EditProfileForm
